import SelectEmailCampaignDialog from "../../../../components/SelectEmailCampaignDialog"
import { getEditorData, useNodeUtils } from "../../utils"

export default function EmailEditor({ open, onClose, node }) {
  const { updateNodeEditorData } = useNodeUtils()

  function handleSelectButtonClicked(selectedCampaign) {
    updateNode(selectedCampaign)
    onClose()
  }

  function handleCampaignCreated(createdCampaign) {
    updateNode(createdCampaign)
  }

  function updateNode(campaign) {
    updateNodeEditorData(node, campaign)
  }

  return (
    <SelectEmailCampaignDialog
      open={open}
      onClose={onClose}
      bodyPropName="html_body"
      primaryButton={{
        text: "Select",
        isLoading: false,
        onClick: handleSelectButtonClicked,
      }}
      campaignsAPIURL="/workflows/api/email/select-campaign/"
      onCampaignCreated={handleCampaignCreated}
      selectedCampaignID={getEditorData(node)?.id}
    />
  )
}
